import React from "react";

export default function Ex2_Model() {
  return (
    <div>
      <h1>Ex2_Model</h1>
      <p>This is the Ex2_Model component.</p>
    </div>
  );
}
